
import { defineComponent, inject, ref, computed } from 'vue'

//services
import PayrollService from "@/core/services/PayrollService"
import { errManager } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
//icons
import { Search } from '@element-plus/icons-vue'

export default defineComponent({
    props: {
        typeRegister: {
            type: String,
            required: true,
            default: ''
        },
        sport: {
            type: null,
            required: false,
            default: {}
        },
        event: {
            type: null,
            required: false,
            default: {}
        }
    },
    emits: ["getSelectRow"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const altura = screen.height - 300;
        const repo = ref(process.env.VUE_APP_REPO)
        const loaderTable = ref(false)
        const listRows = ref<any[]>([])
        const searchText = ref<any>("")
        //get sharing data
        const gblDialog = inject<any>('gblDialog')

        const geDataPayroll = async () => {
            loaderTable.value = true
            await PayrollService.getData({ textSearch: '', 
                status: [1], 
                origin: 'select', 
                gender: props.sport?.gender, 
                typeRegister: props.typeRegister, 
                idevent:props.event?.idevent 
            })
                .then((res) => {
                    loaderTable.value = false
                    listRows.value = res.data.list
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const filteredList = computed(() => {
            return (listRows.value || []).filter(
                (item) =>
                item.firstname.toLowerCase().includes(searchText.value.toLowerCase()) ||
                item.lastname.toLowerCase().includes(searchText.value.toLowerCase()) ||
                item.docnumber.includes(searchText.value.toLowerCase())
            );
        });

        const onOpened = () => {
            geDataPayroll()
        }

        const onClosed = () => {
            searchText.value = ""
            listRows.value = []
        }

        const setSelectRow = (row) => {
            //validar si cumple los requisitos antes de pasar al otro modal de registro
            if (props.typeRegister == 'D' && row.edad > 28) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: "El participante no cumple con la edad requerida para participar como <b>Deportista</b>",
                });
            } else {
                emit("getSelectRow", row)
                gblDialog.value = false
            }

        }

        return {
            t,
            repo,
            altura,
            gblDialog,
            loaderTable,
            listRows,
            searchText,
            //icons
            Search,
            //events
            onOpened,
            onClosed,
            setSelectRow,
            filteredList
        }

    },
})
